/**
 * @description Add the specified number of days to the given date.
 *
 * @param {Date} date Date to be updated.
 * @param {number} days The amount of days to be added.
 *
 * @returns {Date} Updated date with the added days.
 */
export var addDaysToTheGivenDate = function (date, days) {
    if (days === 0) {
        // If 0 days, no operation. Avoids complications with Day Light Savings.
        return date;
    }
    var dateToMutate = new Date(date);
    dateToMutate.setDate(dateToMutate.getDate() + days);
    return dateToMutate;
};
//# sourceMappingURL=addDaysToTheGivenDate.js.map